// https://reactrouter.com/en/main/start/faq#what-happened-to-withrouter-i-need-it
//
// TODO Maybe I should just do what they do above and set all of it to props.router.* I
// did initially and then changed it to just location before I realized I needed params as well.
// But also I thought I read somewhere that withRouter should be used sparingly? I dunno.

import {
  useLocation,
  useParams,
} from "react-router-dom";

function withLocation(Component) {
  function ComponentWithLocationProp(props) {
    let location = useLocation();
    return (
      <Component
        {...props}
        location={ location }
      />
    );
  }

  return ComponentWithLocationProp;
}

function withMatch(Component) {
  function ComponentWithMatchProp(props) {
    let params = useParams();
    return (
      <Component
        {...props}
        match={{ params }}
      />
    );
  }

  return ComponentWithMatchProp;
}

export {withLocation, withMatch};
